var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3868_188448",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3868_188448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0024 15.577C13.1356 15.577 14.098 15.1804 14.8897 14.3872C15.6814 13.5941 16.0772 12.6309 16.0772 11.4978C16.0772 10.3646 15.6806 9.40217 14.8874 8.6105C14.0943 7.81883 13.1311 7.423 11.9979 7.423C10.8648 7.423 9.90237 7.81958 9.1107 8.61275C8.31903 9.40592 7.9232 10.3691 7.9232 11.5023C7.9232 12.6354 8.31978 13.5978 9.11295 14.3895C9.90612 15.1812 10.8693 15.577 12.0024 15.577ZM12.0002 14.2C11.2502 14.2 10.6127 13.9375 10.0877 13.4125C9.5627 12.8875 9.3002 12.25 9.3002 11.5C9.3002 10.75 9.5627 10.1125 10.0877 9.5875C10.6127 9.0625 11.2502 8.8 12.0002 8.8C12.7502 8.8 13.3877 9.0625 13.9127 9.5875C14.4377 10.1125 14.7002 10.75 14.7002 11.5C14.7002 12.25 14.4377 12.8875 13.9127 13.4125C13.3877 13.9375 12.7502 14.2 12.0002 14.2ZM12.0002 18.5C9.89503 18.5 7.9697 17.9384 6.2242 16.8152C4.4787 15.6922 3.08545 14.2148 2.04445 12.3828C1.96112 12.2391 1.9002 12.0943 1.8617 11.9485C1.82337 11.8027 1.8042 11.653 1.8042 11.4995C1.8042 11.346 1.82337 11.1965 1.8617 11.051C1.9002 10.9055 1.96112 10.7609 2.04445 10.6172C3.08545 8.78525 4.4787 7.30775 6.2242 6.18475C7.9697 5.06158 9.89503 4.5 12.0002 4.5C14.1054 4.5 16.0307 5.06158 17.7762 6.18475C19.5217 7.30775 20.9149 8.78525 21.9559 10.6172C22.0393 10.7609 22.1002 10.9057 22.1387 11.0515C22.177 11.1973 22.1962 11.347 22.1962 11.5005C22.1962 11.654 22.177 11.8035 22.1387 11.949C22.1002 12.0945 22.0393 12.2391 21.9559 12.3828C20.9149 14.2148 19.5217 15.6922 17.7762 16.8152C16.0307 17.9384 14.1054 18.5 12.0002 18.5ZM12.0002 17C13.8835 17 15.6127 16.5042 17.1877 15.5125C18.7627 14.5208 19.9669 13.1833 20.8002 11.5C19.9669 9.81667 18.7627 8.47917 17.1877 7.4875C15.6127 6.49583 13.8835 6 12.0002 6C10.1169 6 8.3877 6.49583 6.8127 7.4875C5.2377 8.47917 4.03353 9.81667 3.2002 11.5C4.03353 13.1833 5.2377 14.5208 6.8127 15.5125C8.3877 16.5042 10.1169 17 12.0002 17Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.a8f34e6ec80d3188e494520b2e02cd80.svg";
export { ForwardRef as ReactComponent };